import { Stack, StackPage, StackSwitch, usePersistedStateId } from "@comet/admin";
import PageTitle from "@src/components/headers/PageTitle";
import { FormattedMessage, useIntl } from "react-intl";

import Table from "./Table";
import { ViewPurchase } from "./view/Purchase";

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();
    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.purchases", defaultMessage: "Lizenzverlängerungen" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageTitle>
                        <FormattedMessage id="reviermanager.page.purchases" defaultMessage="Lizenzverlängerungen" />
                    </PageTitle>
                    <Table persistedStateId={persistedStateId} />
                </StackPage>
                <StackPage
                    name="information"
                    title={intl.formatMessage({ id: "reviermanager.pages.purchases.informations", defaultMessage: "Informationen" })}
                >
                    {(id) => <ViewPurchase id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
